import { render, staticRenderFns } from "./OfficerOpenRecruitmentApplyShow.vue?vue&type=template&id=2c202ba4&"
import script from "./OfficerOpenRecruitmentApplyShow.vue?vue&type=script&lang=js&"
export * from "./OfficerOpenRecruitmentApplyShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports